import {
  SET_SRGLINES_FIRST_LOAD,
  SET_SRGLINES_DATA,
  SET_LOADING_SRGLINES_DATA,
  SET_SRGLINES_FILTER,
  SET_SRGLINES_SORTING,
  SET_SRGLINES_ROWS_PER_PAGE,
  SET_ERROR_MESSAGE_SRGLINES_PAGE,
  SET_ERROR_PROMPT_SRGLINES_PAGE,
  SET_SUCCESS_MESSAGE_SRGLINES_PAGE,
  SET_SUCCESS_PROMPT_SRGLINES_PAGE,
  SET_INFO_MESSAGE_SRGLINES_PAGE,
  SET_INFO_PROMPT_SRGLINES_PAGE,
  SET_EDIT_SRGLINES_DATA,
} from "../../actionTypes/smrt/srgLinesActionType";

const initialState = {
  firstLoad: false,
  linesData: {
    items: [],
    totalItem: 0,
  },
  linesFilter: {
    searchBy: "code", // default to: code
    searchInput: "",
  },
  linesSorting: {
    by: "id",
    direction: "asc",
  },
  rowsPerPage: 10,
  loadingLinesData: false,
  isSuccessPromptSrgLines: false,
  isErrorPromptSrgLines: false,
  isInfoPromptSrgLines: false,
  successMessageSrgLines: "",
  errorMessageSrgLines: "",
  infoMessageSrgLines: "",
};

export const srgLinesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  let updated;
  switch (type) {
    case SET_SRGLINES_FIRST_LOAD:
      return { ...state, firstLoad: payload };

    case SET_SRGLINES_DATA:
      return { ...state, linesData: payload };

    case SET_EDIT_SRGLINES_DATA:
      const data = state.linesData.items;
      const objIndex = data.findIndex((obj) => obj.id === payload.id);
      data[objIndex] = payload;
      const editedLinesData = {
        items: data,
        totalItem: state.linesData.totalItem,
      };
      return {
        ...state,
        linesData: editedLinesData,
      };

    case SET_LOADING_SRGLINES_DATA:
      return { ...state, loadingLinesData: payload };

    case SET_SRGLINES_FILTER:
      return { ...state, assetFilter: payload };

    case SET_SRGLINES_SORTING:
      if (payload.reset === true) {
        return {
          ...state,
          assetSorting: {
            by: "id",
            direction: "asc",
          },
        };
      }
      updated = { ...state.assetSorting, ...payload };
      return { ...state, assetSorting: updated };

    case SET_SRGLINES_ROWS_PER_PAGE:
      return { ...state, rowsPerPage: payload };

    case SET_SUCCESS_PROMPT_SRGLINES_PAGE:
      return { ...state, isSuccessPromptSrgLines: payload };

    case SET_SUCCESS_MESSAGE_SRGLINES_PAGE:
      return { ...state, successMessageSrgLines: payload };

    case SET_ERROR_PROMPT_SRGLINES_PAGE:
      return { ...state, isErrorPromptSrgLines: payload };

    case SET_ERROR_MESSAGE_SRGLINES_PAGE:
      return { ...state, errorMessageSrgLines: payload };

    case SET_INFO_PROMPT_SRGLINES_PAGE:
      return { ...state, isInfoPromptSrgLines: payload };

    case SET_INFO_MESSAGE_SRGLINES_PAGE:
      return { ...state, infoMessageSrgLines: payload };

    default:
      return state;
  }
};
